import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

function SyllableSelectionModal({ show, onHide, onSelect }) {
  const syllables = [
    'ka', 'ke', 'ki', 'ko', 'ku',
    'sa', 'se', 'si', 'so', 'su',
    'la', 'le', 'li', 'lo', 'lu',
    'ra', 're', 'ri', 'ro', 'ru',
    'ma', 'me', 'mi', 'mo', 'mu',
    'na', 'ne', 'ni', 'no', 'nu',
    'ta', 'te', 'ti', 'to', 'tu',
    'ba', 'be', 'bi', 'bo', 'bu',
    'pa', 'pe', 'pi', 'po', 'pu',
    'fa', 'fe', 'fi', 'fo', 'fu'
  ];

  const [selectedSyllables, setSelectedSyllables] = useState([]);

  const handleSyllableToggle = (syllable) => {
    setSelectedSyllables(prev => {
      if (prev.includes(syllable)) {
        return prev.filter(s => s !== syllable);
      } else {
        return [...prev, syllable];
      }
    });
  };

  const handleSubmit = () => {
    if (selectedSyllables.length > 0) {
      onSelect(selectedSyllables);
      onHide();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="lg" 
      centered
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>Wähle die Problemsilben</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-4">
          Bitte wähle die Silben aus, mit denen dein Kind Schwierigkeiten hat:
        </p>
        <Row className="g-3">
          {syllables.map(syllable => (
            <Col key={syllable} xs={4} sm={3} md={2}>
              <Form.Check
                type="checkbox"
                id={`syllable-${syllable}`}
                label={syllable.toUpperCase()}
                checked={selectedSyllables.includes(syllable)}
                onChange={() => handleSyllableToggle(syllable)}
                className="text-center"
                style={{ fontSize: '1.1rem' }}
              />
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={() => {
            setSelectedSyllables([]);
            onSelect([]);
            onHide();
          }}
        >
          Alle Silben üben
        </Button>
        <Button 
          variant="primary"
          onClick={handleSubmit}
          disabled={selectedSyllables.length === 0}
          style={{ backgroundColor: 'var(--primary-color)', border: 'none' }}
        >
          Auswahl bestätigen ({selectedSyllables.length} ausgewählt)
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SyllableSelectionModal;